import React from 'react';
import { formatISO9075 } from 'date-fns';
import { Link } from 'react-router-dom';
import './Post.css';
import { CiCalendarDate } from "react-icons/ci";
import { HiOutlinePencilSquare } from "react-icons/hi2";

function Post(props) {
  // const apiUrl = 'http://localhost/server/testServer';
  const apiUrl = 'https://www.albarede.com/server';

  return (
    <div className="post" data-aos='fade-up'>
      <div className="postImage">
        <Link to={`/post/${props.id}`} target='_top'>
          <img src={`${apiUrl}/` + props.files} alt="img article" />
        </Link>
      </div>
      <div className="texts">
        <div className="info">
          <div>
            <HiOutlinePencilSquare />
            <p className="author">{props.author}</p>
          </div>
          <div>
            <CiCalendarDate />
            <time>{formatISO9075(new Date(props.createAt))}</time>
          </div>
        </div>
        <Link className="title" to={`/post/${props.id}`} target='_top'>
          <h2>{props.title}</h2>
        </Link>
        <p className="summary">{props.summary}</p>
        <Link className="more" to={`/post/${props.id}`}>
          تابع القراءة ..
        </Link>
      </div>
    </div>
  );
}

export default Post;
